<template>
  <Dropdown v-if="categories.length" v-model="show" class="mr-3" class-prop="lg:w-144" :mobile-title="name">
    <template #button>
      <button
        class="whitespace-nowrap rounded bg-gray-light p-3 font-medium hover:text-blue focus:outline-none"
        :class="{ 'text-blue': show || filters.category_ids.length }"
        @click="show = !show"
      >
        {{ name }}
        <span v-if="filters.category_ids.length">({{ filters.category_ids.length }})</span>
      </button>
    </template>

    <CheckboxList v-model="categoryIds" :items="categories" :show-search="showSearch" />

    <template #footer>
      <div class="flex justify-between">
        <button v-if="filters.category_ids.length" class="h-10 text-sm font-medium uppercase leading-10" style="letter-spacing: 0.15em;" @click="clearFilter">
          Clear All
        </button>
        <div class="grow text-right">
          <button
            class="letter-sp15 h-10 rounded-md bg-blue px-4 text-sm uppercase leading-10 text-white hover:bg-blue-dark md:px-8"
            :class="{ 'opacity-75': !applyActive, 'cursor-not-allowed': !applyActive }"
            :disabled="!applyActive"
            @click="applyFilter"
          >
            Show
            <span v-if="loading" class="-mt-1 inline-block w-8 align-middle spinner-sm" />
            <span v-else>{{ total }}</span>
            {{ $f.pluralize('result', total, false) }}
          </button>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapState } from 'pinia'
import Dropdown from '~/components/shared/Dropdown'
import CheckboxList from '~/components/shared/CheckboxList'
import { useVenuesStore } from '~/stores/venues'

export default {
  components: { CheckboxList, Dropdown },

  props: {
    filters: { type: Object, required: true },
    name: { type: String, required: true },
    showSearch: { type: Boolean, default: false },
  },

  emits: ['apply', 'update'],

  data: () => ({
    show: false,
    categoryIds: [],
  }),

  computed: {
    ...mapState(useVenuesStore, {
      loading: s => s.totals.loading,
      total: s => s.totals.total,
      categories: 'categories',
    }),

    applyActive () {
      return ! this.loading
    },
  },

  watch: {
    categoryIds (val) {
      this.updateTotals(val)
    },
  },

  methods: {
    applyFilter () {
      this.updateValues(this.categoryIds)
      this.show = false
    },

    updateTotals: debounce(function (val) {
      this.$emit('update', Object.assign({}, this.filters, { category_ids: val }))
    }, 500),

    clearFilter () {
      if (this.filters.category_ids.length) {
        this.updateValues([])
      }
      this.show = false
    },

    updateValues (values) {
      this.$emit('apply', Object.assign({}, { category_ids: values }))
    },
  },
}
</script>
